import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { SharedUiModule } from '@flyfreely-portal-ui/ui';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { JurisdictionsModule } from 'libs/jurisdictions/src/lib/jurisdictions.module';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { RpaModule } from 'libs/rpa/src/lib/rpa.module';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AuthorityModule } from '../authorities.module';
import { OrganisationAuthorityEdit } from './organisation-authority-edit/organisation-authority-edit.component';
import { OrganisationAuthorityList } from './organisation-authority-list/organisation-authority-list.component';

@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        SharedUiModule,
        LoadingIndicatorModule,
        AuthorityModule,
        PopoverModule,
        RpaModule,
        JurisdictionsModule,
        FormsModule,
        ValidationModule,

        EnhancedHelpModule,
        AnalyticsModule
    ],
    declarations: [OrganisationAuthorityList, OrganisationAuthorityEdit],
    exports: [OrganisationAuthorityList, OrganisationAuthorityEdit]
})
export class OrganisationAuthorityModule {}
